import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL, getHeaders } from "../helper/commonApi";
import { useBranding } from "../context/BrandingContext";

const VerifyEmailComponent = () => {
    const navigate = useNavigate();
    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const [timer, setTimer] = useState(60);
    const [loading, setLoading] = useState(false);
    const [resendLoading, setResendLoading] = useState(false);
    const [error, setError] = useState("");
    const inputRefs = useRef([]);
    // const [email, setEmail] = useState(localStorage.getItem('_register_GRE_userEmail'))

    const { colors, portalID } = useBranding();

    const userId = localStorage.getItem('_register_GRE_userId')
    const email = localStorage.getItem('_register_GRE_userEmail');
    const isLogin = localStorage.getItem('_register_GRE_isLogin')
    const isRegister = localStorage.getItem('_register_GRE_is_register')
    const isForgotPassword = localStorage.getItem('_register_GRE_forgot_password')

    useEffect(() => {
        if (!email) {
            navigate('/')
        }
        const countdown = setInterval(() => {
            setTimer((prev) => (prev > 0 ? prev - 1 : 0));
        }, 1000);
        return () => clearInterval(countdown);
    }, []);

    const handleChange = (e, index) => {
        const value = e.target.value.replace(/\D/g, "");

        if (value.length === 6) {
            const newOtp = value.split("").slice(0, 6);
            setOtp(newOtp);
            inputRefs.current[5].focus();
            setError("");
            return;
        }

        if (value.length === 1) {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);
            if (index < 5) inputRefs.current[index + 1].focus();
            setError("");
        }
    };


    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            e.preventDefault();
            const newOtp = [...otp];
            if (otp[index]) {
                newOtp[index] = "";
            } else if (index > 0) {
                newOtp[index - 1] = "";
                inputRefs.current[index - 1].focus();
            }
            setOtp(newOtp);
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (otp.some((digit) => digit === "")) {
            setError("Please enter all 6 digits of the OTP.");
            return;
        }
        const fullOtp = otp.join("");

        // if is forgot password
        if (isForgotPassword) {
            // Store otp and user_id temporarily
            localStorage.setItem("_reset_otp", fullOtp);
            localStorage.setItem("_reset_user_id", userId);
            navigate("/reset-password");
            return;
        }

        setLoading(true);
        setError("");

        try {

            const payload = {
                portal_id: portalID,
                user_id: userId,
                otp: fullOtp
            };

            if (isLogin) {
                payload.is_login = true; // Add this only if login
            }

            if (isRegister) {
                payload.register = 1; // Add this only if register
            }

            const res = await axios.post(`${API_URL}/verify-otp`, payload, {
                headers: getHeaders()
            });

            if (res.status === 200 && res?.data?.status) {
                localStorage.removeItem('_register_GRE_userId')
                localStorage.removeItem('_register_GRE_userEmail')
                localStorage.removeItem('_register_GRE_isLogin')
                localStorage.removeItem('_register_GRE_is_register')

                const userId = res?.data?.data?.user_id;
                const fullName = res?.data?.data?.full_name;
                const token = res?.data?.data?.jwt_token;
                const email = res?.data?.data?.email;

                const tokenExpires = res.data.data.token_expires_in || 18000;
                const expires = new Date(Date.now() + tokenExpires * 1000).toUTCString();

                if (isLogin) {
                    localStorage.setItem('is_login', "true");
                    localStorage.setItem('_register_GRE_LOGIN_userId', userId)
                    localStorage.setItem('_register_GRE_LOGIN_full_name', fullName)
                    localStorage.setItem('_register_GRE_userEmail', email)

                    document.cookie = `_GRE_JWT_TOKEN=${token}; expires=${expires}; path=/; Secure; SameSite=Strict`;

                    navigate("/dashboard");
                } else {
                    navigate("/verify-success");
                }
            } else {
                setError(res?.data?.message || "Invalid OTP.");
            }
        } catch (err) {
            setError("Something went wrong.");
        } finally {
            setLoading(false);
        }
    };

    const handleResendOtp = async () => {
        setResendLoading(true);
        setError("");
        try {
            await axios.post(`${API_URL}/resend-otp`, {
                // site: "omc",
                email: email,
                portal_id: portalID,
                user_id: userId,
            }, {
                headers: getHeaders()
            });
            setOtp(["", "", "", "", "", ""]);
            setTimer(60);
            inputRefs.current[0].focus();
        } catch (err) {
            setError("Failed to resend OTP. Please try again.");
        } finally {
            setResendLoading(false);
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pasteData = e.clipboardData.getData("text").replace(/\D/g, "");
        if (pasteData.length === 6) {
            const newOtp = pasteData.split("").slice(0, 6);
            setOtp(newOtp);
            inputRefs.current[5].focus();
            setError("");
        }
    };


    return (
        <div style={{ margin: "10px" }}>
            <div className="container">
                <div className="verify-otp-section ">
                    <h1>Verify Your Email</h1>
                    <p className="subtitle">
                        An OTP has been sent to <br />
                        <strong>{email}</strong>. Please enter it below
                    </p>

                    <form className="otp-form" onSubmit={handleSubmit}>
                        <div className="otp-inputs">
                            {otp.map((digit, index) => (
                                <input
                                    key={index}
                                    id={`otp-${index}`}
                                    name={`otp-${index}`}
                                    type="text"
                                    inputMode="numeric"
                                    className="otp-input"
                                    value={digit}
                                    onChange={(e) => handleChange(e, index)}
                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                    maxLength={1}
                                    ref={(el) => (inputRefs.current[index] = el)}
                                    onPaste={(e) => handlePaste(e)}
                                />
                            ))}
                        </div>
                        <p className="otp-helper">Enter 6-Digit OTP</p>
                        {error && <p className="verify-otp-error">{error}</p>}
                        <div>
                            <button type="submit" className="btn-verify btn dark" disabled={loading} style={{ background: colors.buttonBg, color: colors?.buttonText }}>
                                {loading ? <span className="create-account-loader-btn" /> : isForgotPassword ? "Continue" : "Verify OTP"}
                            </button>
                        </div>
                    </form>

                    <div className="resend-container">
                        <span className="bottom-text"> Didn't receive the OTP? </span>
                        <button onClick={handleResendOtp} disabled={timer > 0 || resendLoading}
                            className="resend-link-btn">
                            {resendLoading ? <span className="loader-small" /> : "Resend OTP in"}
                        </button>
                        <span className="timer">({timer}s)</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VerifyEmailComponent;
